import React from 'react';
import {SvgIcon} from '@mui/material';
import type {IconProps} from './types';

export const NoneIcon: React.FC<IconProps> = (props: IconProps) => {
  return <SvgIcon {...props} viewBox="0 0 24 24"></SvgIcon>;
};
